import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IMessage } from '~/models/Message';
import { messageKeys } from '../messageKeys';
import { messagesService } from '../messagesService';

export function usePostMessageMutation(jobId: string) {
  const queryClient = useQueryClient();

  return useMutation<IMessage, unknown, string>({
    mutationFn: (message: string) => messagesService.postMessage({ jobId, message }),
    onSuccess: (posted) => {
      queryClient.setQueryData<IMessage[]>(messageKeys.jobMessages(jobId), (prev) => {
        const list = prev ?? [];
        const last = list[list.length - 1];
        // Reducer parity: skip append when the posted id matches the last message id.
        if (list.length !== 0 && last?.id === posted.id) {
          return list;
        }
        return [...list, posted];
      });
    },
  });
}
